import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import usePermissions from '@/permissions/usePermissions';
import ForbiddenPage from '@/pages/error/ForbiddenPage';
import { ROUTES } from './paths';

// Auth + permission gate around a route element.
//  1. not authenticated      → /login (remember where we came from)
//  2. authenticated, no perm  → 403 page
//  3. authenticated + permit  → render children
export default function RouteGuard({ permission, children }) {
  const isAuthenticated = useSelector((s) => s.auth.isAuthenticated);
  const { has } = usePermissions();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }
  if (permission && !has(permission)) {
    return <ForbiddenPage />;
  }
  return children;
}
